import axios, { AxiosInstance } from 'axios';
import { XApp } from '@core/utils';

type InstanceMethod = 'get' | 'delete' | 'patch' | 'put' | 'post';

type AxiosFnToSetup = [any, InstanceMethod];

export const createAxiosInstance = (globalConfigNestedFields?: string[]) => {
  const axiosFnsToSetup: AxiosFnToSetup[] = [
    [axios.get, 'get'],
    [axios.delete, 'delete'],
    [axios.post, 'post'],
    [axios.patch, 'patch'],
    [axios.put, 'put']
  ];

  const axiosObj = axiosFnsToSetup.reduce(
    (acc, [fn, name]) => ({
      ...acc,
      [name]: (endpoint: string, ...rest: any[]) =>
        fn(
          XApp.getApiUrlFromEndpoint(endpoint, globalConfigNestedFields),
          ...rest
        )
    }),
    {}
  );

  return axiosObj as Pick<AxiosInstance, InstanceMethod>;
};
